import { render, staticRenderFns } from "./PolicyModal.vue?vue&type=template&id=5e5fb7af&scoped=true"
import script from "./PolicyModal.vue?vue&type=script&lang=js"
export * from "./PolicyModal.vue?vue&type=script&lang=js"
import style0 from "./PolicyModal.vue?vue&type=style&index=0&id=5e5fb7af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5fb7af",
  null
  
)

export default component.exports